import { Children, cloneElement } from 'react';

import useLogger from '@/hooks/useLogger';
import { LoggerParams } from '@/types/log';

interface Props {
  children: React.ReactElement;
  params: LoggerParams;
}
const ClickLogger = (props: Props) => {
  const {
    children,
    params: { eventName, payload },
  } = props;

  const logger = useLogger();
  const child = Children.only(children);

  return cloneElement(child, {
    onClick: (...args: any[]) => {
      logger.log({ eventName, payload });

      if (child.props && typeof child.props['onClick'] === 'function') {
        return child.props['onClick'](...args);
      }
    },
  });
};

export default ClickLogger;
